<template>
  <div class="new-system">
    <pageTitle></pageTitle>
    <div class="bg-dark system-info">
      <div v-if="cardType==='info'" class="base-info">
        <p class="header">
          基本信息创建
        </p>
        <div class="form-body">
          <form>
            <div class="form-group">
              <label>系统名称</label>
              <input v-model="systemInfo.name" type="text" class="form-control" placeholder="">
            </div>
            <div class="form-group">
              <label>系统简介</label>
              <textarea  v-model="systemInfo.description" type="text" class="form-control" placeholder=""></textarea>
            </div>
            <div class="d-flex">
              <button type="button" @click="nextSystemSetting('info')" class="btn btn-primary ml-auto">继续</button>
            </div>
          </form>
        </div>
      </div>
      <div v-if="cardType==='data'" class="data">
        <p class="header">
          数据包规则创建
        </p>
        <div class="data-info">
          <steps @clickStep="changeDataSteps" :index="packetRuleIndex" :steps="steps"></steps>
          <div v-if="packetRuleIndex===1" class="form-body">
            <form>
              <div class="form-group">
                <label>连接超时时间(s)</label>
                <input type="text" v-model.number="packetRule.timeout" class="form-control" placeholder="">
              </div>
              <div class="form-group">
                <label>长度</label>
                <div class="d-flex align-items-start">

                  <div>
                    <div class="form-inline">
                      <input type="text" v-model="packetRule.len.pt[0]" class="form-control mr-2" placeholder="">
                      <span class="mr-2">--</span>
                      <input type="text" v-model="packetRule.len.pt[1]" class="form-control mr-4" placeholder="">
                    </div>
                    <small class="text-text">
                      坐标范围
                    </small>
                  </div>
                  <div class="form-group mr-4">
                    <input  v-model.number="packetRule.ctStPt" type="text" class="form-control mr-2" placeholder="">
                    <small class="text-text">
                      长度包含固定内容起始坐标
                    </small>
                  </div>
                  <div class="form-group mr-4">
                    <input v-model.number="packetRule.len.ctCtLen"  type="text" class="form-control mr-2" placeholder="">
                    <small class="text-text">
                      固定内容长度
                    </small>
                  </div>
                  <select v-model="packetRule.len.ayl" style="width: 200px;" class="form-control" name="" id="">
                    <option selected>解析方式</option>
                  </select>
                </div>
              </div>
              <div class="d-flex">
                <div class="ml-auto">
                  <button type="button" @click="preSystemSetting('data')" class="btn btn-link ">上一步</button>
                  <button type="button" @click="nextSystemSetting('data')" class="btn btn-primary">继续</button>
                </div>
              </div>
            </form>
          </div>

          <!--包头包尾命令关键字设置-->
          <div v-if="packetRuleIndex===2" class="form-body">
            <form>
              <div class="form-group  mr-4">
                <div class="d-flex">
                  <label class="mr-5">包头</label>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" v-model="packetRuleOpt.headIsKey" class="custom-control-input" id="head-is-key">
                    <label class="custom-control-label" for="head-is-key">是否将包头设为关键字</label>
                  </div>
                </div>
                <data-arr v-model="packetRule.head.ct"></data-arr>
              </div>

              <div class="form-group  mr-4">
                <div>
                  <label>包尾设置</label>
                </div>
                <data-arr v-model="packetRule.tail"></data-arr>

              </div>
              <div class="form-group  mr-4">
                <div>
                  <label>命令关键字范围</label>
                </div>
                <div class="d-flex">
                  <div>
                    <div class="form-inline">
                      <input v-model="packetRule.key.pt[0]" type="text" class="form-control mr-2" placeholder="">
                      <span class="mr-2">--</span>
                      <input v-model="packetRule.key.pt[1]" type="text" class="form-control mr-4" placeholder="">
                    </div>
                    <small class="text-text">
                      坐标范围
                    </small>
                  </div>
                  <data-arr text="内容" v-model="packetRule.key.ct"></data-arr>
                </div>
              </div>

              <div class="d-flex">
                <div class="ml-auto">
                  <button @click="preSystemSetting('data')" type="button" class="btn btn-link ">上一步</button>
                  <button @click="nextSystemSetting('data')" type="button" class="btn btn-primary ">继续</button>

                </div>
              </div>
            </form>
          </div>
          <!--校验码-->
          <div v-if="packetRuleIndex===3" class="form-body">
            <div class="form-group">
              <label>校验码</label>

              <div class="d-flex align-items-start">
                <div>
                  <div class="form-inline">
                    <input v-model="packetRule.ck.pt[0]" type="text" class="form-control mr-2" placeholder="">
                    <span class="mr-2">--</span>
                    <input v-model="packetRule.ck.pt[1]" type="text" class="form-control mr-4" placeholder="">
                  </div>
                  <small class="text-text">
                    校验码坐标
                  </small>
                </div>
                <select v-model="packetRule.ayl" style="width: 200px;" class="form-control mr-4" name="">
                  <option selected>解析方式</option>
                </select>
                <div class="form-group mr-4">
                  <input v-model.number="packetRule.ctStPt" type="text" class="form-control " placeholder="">
                  <small class="text-text">
                    固定内容起始坐标
                  </small>
                </div>

                <div class="form-group mr-4">
                  <input v-model.number="packetRule.ctCtLen" type="text" class="form-control " placeholder="">
                  <small class="text-text">
                    固定内容长度
                  </small>
                </div>
              </div>
            </div>
            <div class="d-flex">
                  <div class="ml-auto">
                  <button type="button" @click="preSystemSetting('data')" class="btn btn-link ">上一步</button>
                  <button type="button" @click="nextSystemSetting('data')" class="btn btn-primary">继续</button>
                </div>
            </div>
          </div>

        </div>

      </div>

      <!--握手包 Handshake Packet-->
      <div v-if="cardType==='handShake'" class="hand-shake">
        <p class="header">
          握手功能创建
          <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#newModal">编辑握手次数</button>
        </p>
        <div class="function">
          <div class="function-list">
            <template v-for="(stream,handIndex) in wsPacket">
              <div @click="selectHandShake(handIndex,'UP')" :key="handIndex+'up'" :class="{'selected':handIndex===handShake.index&&handShake.type==='UP'}"
                   class="list-item ">第{{handIndex+1}}次上行
              </div>
              <div @click="selectHandShake(handIndex,'DOWN')" :key="handIndex+'down'" :class="{'selected':handIndex===handShake.index&&handShake.type==='DOWN'}"
                   class="list-item ">第{{handIndex+1}}次下行
              </div>
            </template>
            <div>
              <button @click="nextSystemSetting('handShake')" class="btn btn-primary">继续</button>
            </div>
          </div>
          <div class="function-info">
            <template v-for="(stream,handIndex) in wsPacket">
              <upstream :key="handIndex+'up'" type="WS" v-show="handIndex===handShake.index&&handShake.type==='UP'"></upstream>
              <downstream :key="handIndex+'down'" type="WS" v-show="handIndex===handShake.index&&handShake.type==='DOWN'"></downstream>
            </template>

          </div>
        </div>


      </div>
      <!--心跳包 Heartbeat-->
      <div v-if="cardType==='heartBeat'" class="heart-beat">
        <p class="header">
          心跳功能创建
        </p>
        <div class="function">
          <div class="function-list">
            <template v-for="(stream,heartIndex) in xtPacket">
              <div @click="selectXT(heartIndex,'UP')" :key="heartIndex+'up'" :class="{'selected':heartBeat.type==='UP'}"
                   class="list-item">第{{heartIndex+1}}次上行
              </div>
              <div @click="selectXT(heartIndex,'DOWN')" :key="heartIndex +'down'" :class="{'selected':heartBeat.type==='DOWN'}"
                   class="list-item">第{{heartIndex+1}}次下行
              </div>
            </template>

            <button @click="createdSystem" class="btn btn-success">创建子系统</button>
          </div>
          <div class="function-info">
            <template v-for="(stream,heartIndex) in xtPacket">
              <upstream  v-model="stream.up" v-show="heartBeat.type==='UP'" type="XT" :key="heartIndex+'up'"></upstream>
              <downstream v-model="stream.up" v-show="heartBeat.type==='DOWN'" type="XT" :key="heartIndex +'down'"></downstream>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- modaL~~~ -->


    <!-- Modal -->
    <div class="modal fade" id="newModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog " role="document">
        <div class="modal-content bg-dark">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">握手次数设置</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>握手次数</label>
              <select @change="changeHandTimes" v-model="handShake.times" class="form-control">
                <option  v-for="one in 12" :value="one" :key="one">{{one}}次</option>
              </select>
              <small id="emailHelp" class="form-text text-text">握手次数会决定上下行数量</small>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import pageTitle from "@/components/pageTitle";
import steps from "./steps";
import textInput from "./text-input";
import upstream from "./upstream";
import downstream from "./downstream";
import dataArr from "./data-arr";

export default {
  name: "new-system",
  components: {
    pageTitle,
    steps,
    textInput,
    upstream,
    downstream,
    dataArr
  },
  created() {
    $(".custom-control").prop("indeterminate", true);
  },
  data() {
    return {
      type: "NEW",
      systemInfo: {
        name: "", // 名称
        description: "", // 简介
        packet_rule: {}, //数据包规则
        ws_packet: [], //握手包
        xt_packet: [] // 心跳包
      },
      packetRule: {
        timeout: "", //连接超时时间
        len: {
          pt: [0, 0],
          ayl: "",
          ctStPt: "",
          ctCtLen: "" //# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
        },
        count: "", //数据包总长度(心跳握手特有)
        head: { ct: [2, 3] }, //包头{ 包头内容, 包头坐标 }
        tail: { ct: [2, 3] }, //包尾
        ck: { pt: [], ayl: "", ctStPt: 3, ctCtLen: 3 }, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
        key: { ct: [255], pt: [] } // 功能key{ 功能key内容, 功能key坐标 }
      },
      packetRuleOpt: {
        headIsKey: false
      },
      wsPacket: [],
      xtPacket: [],
      example: {
        steam: {
          up: {
            packetRule: {},
            ct: [],
            devId: { pt: [], ayl: "" }
          },
          dw: {
            packetRule: {},
            ct: []
          }
        }
      },
      cardType: "info",
      a: "1",
      packetRuleIndex: 1,
      index: 3,
      steps: [
        {
          title: "连接超时时间与长度"
        },
        {
          title: "包头包尾与命令关键字"
        },
        {
          title: "校验码"
        }
      ],
      handShake: {
        index: 0,
        times: 0,
        type: ""
      },
      heartBeat: {
        index: 0,
        times: 0,
        type: ""
      },
      functionIndex: 1
    };
  },
  created() {
    // 初始化上下行数据包规则
    this.example.steam.up.packetRule = this.packetRule;
    this.example.steam.dw.packetRule = this.packetRule;
  },
  methods: {
    // creat 子系统
    createdSystem() {
      const packRule = {
        timeout: 60, //连接超时时间
        len: {
          pt: [0, 1],
          ayl: 501,
          ctStPt: 0,
          ctCtLen: null //# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
        },
        count: null, //数据包总长度(心跳握手特有)
        head: null, //包头{ 包头内容, 包头坐标 }
        tail: null, //包尾
        ck: null, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
        key: {
          ct: null,
          pt: [2, 2]
        }
      }; // 功能key{ 功能key内容, 功能key坐标 }
      const ws = [
        {
          dataChangeType: 0,
          up: {
            packetRule: {
              timeout: 60, //连接超时时间
              len: {
                pt: [0, 1],
                ayl: 501,
                ctStPt: 0,
                ctCtLen: 9 //# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
              },
              count: 11, //数据包总长度(心跳握手特有)
              head: null, //包头{ 包头内容, 包头坐标 }
              tail: null, //包尾
              ck: null, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
              key: {
                ct: 0x02,
                pt: [2, 2]
              }
            }, // 功能key{ 功能key内容, 功能key坐标 },
            ct: null,
            devId: {
              pt: [3, 10],
              ayl: 5017
            }
          },
          dw: null
        }
      ];

      const xt = [
        {
          dataChangeType: 0,
          up: {
            packetRule: {
              timeout: 60, //连接超时时间
              len: {
                pt: [0, 1],
                ayl: 501,
                ctStPt: 0,
                ctCtLen: 9 //# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
              },
              count: 11, //数据包总长度(心跳握手特有)
              head: null, //包头{ 包头内容, 包头坐标 }
              tail: null, //包尾
              ck: null, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
              key: {
                ct: 0x02,
                pt: [2, 2]
              }
            }, // 功能key{ 功能key内容, 功能key坐标 },
            ct: null,
            devId: null
          },
          dw: {
            packetRule: {
              timeout: 60, //连接超时时间
              len: {
                pt: [0, 1],
                ayl: 501,
                ctStPt: 0,
                ctCtLen: 9 //# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
              },
              count: 11, //数据包总长度(心跳握手特有)
              head: null, //包头{ 包头内容, 包头坐标 }
              tail: null, //包尾
              ck: null, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
              key: {
                ct: 0x02,
                pt: [2, 2]
              }
            }, // 功能key{ 功能key内容, 功能key坐标 },
            ct: [
              0x00,
              0x09,
              0x02,
              0x4c,
              0x4d,
              0x53,
              0x5a,
              0x33,
              0x30,
              0x30,
              0x31
            ]
          }
        }
      ];

      let url = "/categories/create",
        params = {
          auth_token: "default",
          name: this.systemInfo.name,
          description: this.systemInfo.description,
          frequency: "30", //页面刷新频率
          // packet_rule: JSON.stringify(this.packetRule),
          // ws_packet: JSON.stringify(this.wsPacket),
          // xt_packet: JSON.stringify(this.xtPacket)
          packet_rule: JSON.stringify(packRule),
          ws_packet: JSON.stringify(ws),
          xt_packet: JSON.stringify(xt)
        };
      this.$http.post(url, params).then(res => {
        if (res.status_code === "SUCCEEDED") {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });
    },

    changeDataSteps(index) {
      this.packetRuleIndex = index + 1;
    },

    addDataArr(arr) {
      arr.push(255);
    },
    //下一步
    nextSystemSetting(type) {
      switch (type) {
        case "info":
          this.cardType = "data";
          break;
        case "data":
          if (this.packetRuleIndex < 3) {
            this.packetRuleIndex++;
          } else {
            this.cardType = "handShake";
            if (this.handShake.times <= 0) {
              $("#newModal").modal("show");
            }
          }

          break;
        case "handShake":
          this.cardType = "heartBeat";
          this.setXtData();
          break;
      }
    },
    preSystemSetting(type) {
      switch (type) {
        case "info":
          // this.cardType='data';
          break;
        case "data":
        if(this.packetRuleIndex>1){
          this.packetRuleIndex--
        }else{
          this.cardType = "info";
        }
          break;
        case "handShake":
          this.cardType = "data";
      }
    },
    //修改握手次数
    changeHandTimes() {
      let ex = this.example.steam;
      this.wsPacket = [];
      for (let i = 0; i < this.handShake.times / 2; i++) {
        this.wsPacket.push(ex);
      }
      this.selectHandShake(0,'UP')
    },
    selectHandShake(index, type) {
      this.handShake.index = index;
      this.handShake.type = type;
    },

    //填充心跳包数据
    setXtData() {
      if (this.type === "NEW") {
        this.xtPacket.push(this.example.steam);
      }
    },

    // 选择心跳上下行
    selectXT(index, type) {
      this.heartBeat.type = type;
    }
  }
};
</script>

<style lang="scss" scoped>
.system-info {
  padding: 30px 60px;

  .header {
    font-size: pxTorem(22px);
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #1f2037;
  }
}
.base-info {
  .form-control {
    max-width: 500px;
  }
}
.form-body {
  padding: 5rem 0;
}

.data {
  .form-control {
    max-width: 150px;
  }
}
.data-info {
  padding: 0 2rem;
}

.data-header-style {
  display: flex;
  align-items: flex-start;
  .data-arr {
    position: relative;
  }
  .data-arr-delete {
    position: absolute;
    right: 0;
    top: -11px;
    z-index: 3;
    color: #fff;
    background: $primary;
    width: 1.2rem;
    border-radius: 50%;
    height: 1.2rem;
    text-align: center;
    line-height: 1.2rem;
    cursor: pointer;
  }
  .icon-c_add {
    line-height: 38px;
    font-size: 2rem;
    cursor: pointer;
  }
}

/*功能上下行编辑*/
.function {
  display: flex;

  .function-list {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .list-item {
      border: 1px dashed #fff;
      border-right: none;
      border-radius: 10px 0 0 10px;
      margin-bottom: 1rem;
      padding: 1rem 2rem;
      cursor: pointer;
    }
    .list-item.selected {
      padding: 1rem 2.3rem;
      background: #fff;
      color: #000;
      border: none;
    }
  }

  .function-info {
    border: 1px solid #fff;
    border-radius: 5px;
    flex: 1;
    padding: 2rem 4rem;

    .form-body {
      padding: 4rem 0;
    }
  }

  .text-input {
    width: 125px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/subSystem/new.vue